import React from 'react';
import { Data, DataState } from '../../types/data-providers';
import * as ChartManager from '../domain/chart-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { PhaseResolvedGraphData } from '../../types/device';

type PhaseResolvedContext = {
    responsePRData: Data<any>;
    fetchPRData: Function;
};

const Context = React.createContext<PhaseResolvedContext | null>(null);

function usePRGraphDetails(): PhaseResolvedContext {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('usePhaseresolvedGraph details must be used within a PR Graph');
    }
    return contextState;
}

const PhaseResolvedGraphProvider: React.FC<{
    deviceId: string;
    channelNumber: number;
    graphDate: string;
    filterChecked?: boolean;
    pdConversion?: string;
    phaseValue?: string;
}> = (props) => {
    const authHelper = useAuthHelper();

    const [responsePRData, setResponsePRData] = React.useState<Data<any>>({ state: DataState.Loading });

    const phaseResolvedResult = React.useCallback(
        async (
            channelNumberIdentifier: number,
            graphDate: string,
            filterChecked?: boolean,
            pdConversion?: string,
            phaseConnectionValue?: string
        ) => {
            setResponsePRData({
                state: DataState.Loading,
            });
            const data = await ChartManager.getPhaseResolvedtWithData(
                authHelper,
                props.deviceId,
                channelNumberIdentifier,
                graphDate,
                filterChecked,
                pdConversion,
                phaseConnectionValue
            );

          return data;

           // eslint-disable-line react-hooks/exhaustive-deps
        },       
         [authHelper,props.deviceId]
    );

    const fetchPRData = async (
        channelNumberIdentifier: number,
        graphDate: string,
        filterChecked?: boolean,
        pdConversion?: string,
        phaseConnectionValue?: string
    ): Promise<PhaseResolvedGraphData> => {
        const data = await phaseResolvedResult(
            channelNumberIdentifier,
            graphDate,
            filterChecked,
            pdConversion,
            phaseConnectionValue
        );

        setResponsePRData({
            state: DataState.Loaded,
            value: data,
        });

        return data;
    };

    return <Context.Provider value={{ responsePRData, fetchPRData }}>{props.children}</Context.Provider>;
};

const TestPhaseResolvedGraphProvider: React.FC<{ value: PhaseResolvedContext }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { PhaseResolvedGraphProvider, TestPhaseResolvedGraphProvider, usePRGraphDetails };
